import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import HomePage from "./pages/HomePage";
import LogIn from "./pages/LogIn";
import SignUp from "./pages/SignUp";
import SightingImage from "./pages/SightingImage";
import { userConfirmation } from "./components/utilities";
import SightingData from "./pages/SightingData";
import ProfilePage from "./pages/ProfilePage";
import SightingDetails from "./pages/SightingDetailsPage";
import ErrorPage from "./pages/ErrorPage";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import FAQs from "./pages/FAQ";
import GettingStarted from "./pages/GettingStarted";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    loader: userConfirmation,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "/signup/",
        element: <SignUp />,
      },
      {
        path: "/login/",
        element: <LogIn />,
      },
      {
        path: "/forgot-password/",
        element: <ForgotPassword />,
      },
      {
        path: "/reset-password/:token",
        element: <ResetPassword />,
      },
      {
        path: "/sightingData/",
        element: <SightingData />,
      },
      {
        path: "/sightingImage/",
        element: <SightingImage />,
      },
      {
        path: "/faq/",
        element: <FAQs />,
      },
      {
        path: "/getting-started/",
        element: <GettingStarted />,
      },
      {
        path: "/profile/:profileId",
        element: <ProfilePage />,
        children: [
          {
            path: "sighting/:sightingId",
            element: <SightingDetails />,
          },
        ],
      },
    ],
    errorElement: <ErrorPage />
  },
]);

export default router;
